import { storageApiRef } from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  DefaultShortcutsApi,
  shortcutsApiRef,
} from '@backstage-community/plugin-shortcuts';

/**
 * Registers the shortcuts API for the community shortcuts plugin.
 * The classic plugin does not export an NFS-compatible feature, so
 * we bridge the API manually. Attached to `app` to ensure it loads.
 */
export const shortcutsApiModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ApiBlueprint.make({
      name: 'shortcuts',
      params: params =>
        params({
          api: shortcutsApiRef,
          deps: { storageApi: storageApiRef },
          factory: ({ storageApi }) =>
            new DefaultShortcutsApi(storageApi.forBucket('shortcuts')),
        }),
    }),
  ],
});
